import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, Title } from "@angular/platform-browser";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import { Industry } from '../../models/common/industry.model';
import { Webinar } from '../../models/webinars/webinar.model';
import { PrimaryIndustryService } from '../../services/primary-industry.service';
import { ResourcesService } from '../../services/resources.service';
import { ToastsService } from '../../services/toasts.service';
import { WebinarsOnDemandService } from '../../services/webinars-on-demand.service';
import { Base } from '../base/base';
import { EventTrackingService } from 'src/app/services/event-tracking.service';
import { EventName } from '../../../environments/environment';

@Component({
  selector: 'safetydirector-webinars-on-demand-card',
  templateUrl: './webinars-on-demand-card.component.html',
  styleUrls: ['./webinars-on-demand-card.component.css']
})
export class WebinarsOnDemandCardComponent extends Base implements OnInit, OnDestroy {
  private BusyA;
  private BusyB;
  public industry: string | null = null;
  public webinarsCopy: Webinar[] | any;
  public webinars: Webinar[] | any;
  public selectedWebinar: Webinar;
  public selectedWebinarUrl: SafeResourceUrl;

  public selectedIndustry: string;
  public primaryIndustries: Industry[];
  public featuredTopics: any;
  public featuredTopicsCheckArray: Array<string> = [];
  public secondaryFeaturedTopics: any;
  public secondaryFeaturedTopicsCheckArray: Array<string> = [];

  public pageName = "Webinars on Demand";
  public searchString: string | null = null;
  public subheadingLength = 80;

  constructor(
    private webinarsOnDemandService: WebinarsOnDemandService,
    private sanitized: DomSanitizer,
    private resourcesService: ResourcesService,
    private toastsService: ToastsService,
    private primaryIndustryService: PrimaryIndustryService,
    private modalService: NgbModal,
    private titleService: Title,
    private eventTrackingService: EventTrackingService
    ) {
    super();
    this.titleService.setTitle(this.basePageTitle + this.pageName);
    
  }

  ngOnInit(): void {
    this.industry = this.getIndustry();
    this.selectedIndustry = this.industry;

    this.initializeWebinars();
  }

  public initializeWebinars(clearSearch = false) {
    if (clearSearch) {
      this.searchString = null;
    }

    this.featuredTopicsCheckArray = [];
    this.secondaryFeaturedTopicsCheckArray = [];

    this.BusyA = this
      .webinarsOnDemandService
      .getWebinars(this.selectedIndustry!, this.searchString!)
      .subscribe(result => {
        this.webinarsCopy = result;
        this.webinars = result;

        if (this.searchString) {
          this.filterWebinars();
        } else {
          this.initializeRefiners();
        }
      });

    this.BusyB = this
      .primaryIndustryService
      .getIndustries()
      .subscribe(result => {
        this.primaryIndustries = result;
      });
  }

  public filterWebinars(clearSearch = false) {
    var filterwebinar = '';
    this.webinars = this.webinarsCopy;

    if (clearSearch) {
      this.searchString = null;
    }

    // search string
    if (this.searchString) {     
      let ss = this.searchString.toLowerCase();
      this.webinars = _.filter(this.webinars, function (r) {
        return (r.title && r.title.toLowerCase().includes(ss)) ||
          (r.subheading && r.subheading.toLowerCase().includes(ss)) ||
          (r.primaryFeatureTopic && r.primaryFeatureTopic.toLowerCase().includes(ss)) ||
          (r.secondaryFeaturedTopic && r.secondaryFeaturedTopic.join('|#|~~|#|').toLowerCase().includes(ss));
      });
    }
    // filter featured topics
    if (this.featuredTopicsCheckArray && this.featuredTopicsCheckArray.length > 0) {    
      let ftcArray = this.featuredTopicsCheckArray;
      this.webinars = _.filter(this.webinars, function (r) {
        return _.find(ftcArray, ftc => ftc == r.primaryFeatureTopic) && true;
      });
    }
    // filter secondary featured topics
    if (this.secondaryFeaturedTopicsCheckArray && this.secondaryFeaturedTopicsCheckArray.length > 0) {    
      let stcArray = this.secondaryFeaturedTopicsCheckArray;
      this.webinars = _.filter(this.webinars, function (r) {
        return _.find(stcArray, stc => r.secondaryFeaturedTopic.join('|#|~~|#|').includes(stc)) && true;
      });
    }

    this.initializeRefiners();
  
  }

  public initializeRefiners() {
    // Featured Topics
    this.featuredTopics = _.filter(_.sortBy(_.uniq(_.map(this.webinars, 'primaryFeatureTopic'))), function (f) { return f });

    // Secondary Featured Topics
    this.secondaryFeaturedTopics = _.filter(_.sortBy(_.uniq(_.flatten(_.map(this.webinars, 'secondaryFeaturedTopic')))), function (s) { return s });
  }

  public onCheckboxChange(e, filter) {
    var checkboxchangeFilter = '';
    if (e.target.value && e.target.checked) {
      if (filter == 'featuredTopic') {
        checkboxchangeFilter=filter
        if (this.featuredTopicsCheckArray && !_.find(this.featuredTopicsCheckArray, f => f == e.target.value)) {
          this.featuredTopicsCheckArray.push(e.target.value);
        }
      } else if (filter == 'secondaryFeaturedTopic') {
        checkboxchangeFilter = filter;
        if (this.secondaryFeaturedTopicsCheckArray && !_.find(this.secondaryFeaturedTopicsCheckArray, s => s == e.target.value)) {
          this.secondaryFeaturedTopicsCheckArray.push(e.target.value);
        }
      }

      e.target.checked = false;
    }

    this.filterWebinars();
    if (filter == 'featuredTopic') {
      // track OnCheckbox change event for featuredTopic.
      this.eventTrackingService.trackEvent('TrackEvent', {
        'Event': EventName.webinarOnDemandFeaturedTopicFilter
        , 'FilterValue': e.target.value
      });
    }
    else if (filter == 'secondaryFeaturedTopic') {
      // track OnCheckbox change event for secondary featured topic.
      this.eventTrackingService.trackEvent('TrackEvent', {
        'Event': EventName.webinarOnDemandSecondaryFeaturedTopicFilter
        , 'FilterValue': e.target.value
      });
    }
  }

  public onClearRefiner(r, filter) {
  
    if (r) {
      if (filter == 'featuredTopic') {     
        if (this.featuredTopicsCheckArray && _.find(this.featuredTopicsCheckArray, d => d == r)) {
          _.remove(this.featuredTopicsCheckArray, f => f == r)
        }
      } else if (filter == 'secondaryFeaturedTopic') {       
        if (this.secondaryFeaturedTopicsCheckArray && _.find(this.secondaryFeaturedTopicsCheckArray, d => d == r)) {
          _.remove(this.secondaryFeaturedTopicsCheckArray, s => s == r)
        }
      }
    }

    this.filterWebinars();
    // track Clear Refiner event
    this.eventTrackingService.trackEvent('TrackEvent', {
      'Event': EventName.webinarOnDemandClearRefiner
      , 'ClearFilter': filter 
    });
  }

  public onResetRefiner(filter) {
    if (filter == 'featuredTopic') {
      this.featuredTopicsCheckArray = [];
    } else if (filter == 'secondaryFeaturedTopic') {
      this.secondaryFeaturedTopicsCheckArray = [];
    }

    this.filterWebinars();
  }

  // Show more of the subheading
  public toggleSubheading(webinar: Webinar) {
    if (webinar.more) {
      webinar.more = false
    } else {
      webinar.more = true;
    }
  }

  openModal(targetModal, webinar) {
    const modalRef = this.modalService.open(targetModal, {
      centered: true,
      backdrop: 'static',
      size: 'xl'
    });

    this.selectedWebinar = webinar;
    this.selectedWebinarUrl = this.sanitized.bypassSecurityTrustResourceUrl(webinar.url);
    // track open modal event
    this.eventTrackingService.trackEvent('TrackEvent', {
      'Event': EventName.webinarOnDemandOpenModal
      , 'Webinar': this.selectedWebinar.title 
    });
  }

  public downloadFile(file, fileIcon) {
    let fileName = file.blobName;

    // track download file event
    this.eventTrackingService.trackEvent('TrackEvent', {
      'Event' : EventName.webinarOnDemandDownloadFile
      ,'FileName': fileName
    });
    // Replace the file icon with a spinner, save the original icon to replace when download is complete
    let originalFileIconSrc = fileIcon.src;
    fileIcon.src = "../../assets/images/spinner.gif"
    this.BusyB = this
      .resourcesService
      .downloadWebinarFile(fileName, file.lookupId)
      .subscribe(result => {
        const a = document.createElement('a')
        const objectUrl = URL.createObjectURL(result)
        a.href = objectUrl
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(objectUrl);
        // Put back the original icon
        fileIcon.src = originalFileIconSrc;
        this.toastsService.showSuccess(`Successfully downloaded '${fileName}'`);
      });
  }

  public updateIndustry(industry: string): void {
    this.selectedIndustry = industry;
    this.searchString = null;
    this.initializeWebinars();
    // track update industry
    this.eventTrackingService.trackEvent('TrackEvent', {
      'Event': EventName.webinarOnDemandUpdateIndustry
      , 'Industry': industry
    });
  }

  ngOnDestroy(): void {
    if (this.BusyA) {
      this.BusyA.unsubscribe();
    }

    if (this.BusyB) {
      this.BusyB.unsubscribe();
    }
  }
}
